<template>
  <div class="feed-drawer-wrapper">
    <div class="feed-menu-container">
      <swiper class="feed-menu-swiper" :options="swiperOption">
        <swiper-slide class="feed-menu-menu-box">
          <div class="feed-tab" :class="socialtab == 1 ? 'active' : ''" @click="socialtab = 1">
            <span>{{ $t("components.socialhub.socialHub.stream") }}</span>
          </div>

          <div class="feed-tab" :class="socialtab == 2 ? 'active' : ''" @click="socialtab = 2">
            <span>{{ $t("components.socialhub.socialHub.drafts") }}</span>
          </div>

          <div class="feed-tab" :class="socialtab == 3 ? 'active' : ''" @click="socialtab = 3">
            <span>{{ $t("components.socialhub.socialHub.settings") }}</span>
          </div>
        </swiper-slide>
      </swiper>
      <div class="icon-box-area" @click="$helpMe('https://holacon.com/product-guide/detail/how-to-use-social-hub')">
        <i class="fas fa-life-ring" style="align-self:center"></i>
      </div>
    </div>
    <SocialHubFeed v-if="socialtab == 1" />
    <SocialHubDrafts v-if="socialtab == 2" />
    <SocialHubSettings v-if="socialtab == 3" />
  </div>
</template>

<script>
import SocialHubFeed from "@/components/socialhub/SocialHubFeed";
import SocialHubDrafts from "@/components/socialhub/SocialHubDrafts";
import SocialHubSettings from "@/components/socialhub/SocialHubSettings";
export default {
  components: { SocialHubDrafts, SocialHubFeed, SocialHubSettings },
  data() {
    return {
      socialtab: 1,
      swiperOption: {
        slidesPerView: "auto"
      }
    };
  },
  created() {
    var channelId = "event-social-hub-" + this.$store.state.event.event.id;
    this.$socket.emit("subscribe", {
      channel: channelId,
      token: ""
    });

    this.$socket.on("subscribe_success", data => {
      console.log(data);
    });
  }
};
</script>

<style lang="less">
.feed-drawer-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 100%;
  .feed-menu-container {
    display: flex;
    flex-direction: row;
    gap: 5px;
    .icon-box-area {
      display: flex;
      align-self: center;
      align-items: center;
      justify-content: center;
      border-radius: 8px;
      padding: 6px;
      border: 1px solid #C8CDD3;
      cursor: pointer;
      background-color: white;
      aspect-ratio: 1;
      margin-right: 10px;
      i {
        color: #292f3b;
      }
    }
  }
  .feed-menu-swiper {
    width: calc(~"100% - 20px");
    margin-top: 5px;
    border-bottom: 1px solid #f1f3f6;

    .feed-menu-menu-box {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;

      .feed-tab {
        margin: 8px 30px;
        cursor: pointer;

        &.active {
          position: relative;

          span {
            color: #292f3b !important;
            font-weight: 500;
          }

          &:before {
            content: "";
            width: calc(~"100% + 20px");
            height: 2px;
            background-color: #03658c;
            display: block;
            margin-top: 26px;
            margin-left: -10px;
            position: absolute;
          }
        }

        span {
          color: #8c929c;
          font-size: 13px;
          font-weight: 500;
          margin: 0px;
          padding: 0px;
          line-height: 14px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/socialhub/SocialHub.vue